/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback } from "react";
import { Button } from "../form";
import PropTypes from "prop-types";

const Paginator = (props) => {
  const {
    totalRecords,
    defaultRows,
    onPaginateData,
    isFromPatientDetail,
    isFromTodo,
    selcetedPeriod,
    activePage,
  } = props;
  const [pages, setPages] = useState([1, 2, 3]);
  const [onLastPage, setOnLastPage] = useState(false);
  const [calculatedPages, setCalculatedPages] = useState(0);
  const [page, setPage] = useState(1);

  const checkLastPage = useCallback(
    (p, r) => setOnLastPage(p * r >= totalRecords),
    [totalRecords]
  );

  useEffect(() => {
    let possiblePage = Math.ceil(totalRecords / defaultRows);
    if (page > possiblePage) {
      possiblePage = possiblePage === 0 ? 1 : possiblePage;
      setPage(possiblePage);
      setPages(
        possiblePage === 1
          ? [possiblePage, possiblePage + 1, possiblePage + 2]
          : [possiblePage - 1, possiblePage, possiblePage + 1]
      );
      onPaginateData(defaultRows, possiblePage);
    }
    setCalculatedPages(possiblePage);
    checkLastPage(page, defaultRows);
  }, [checkLastPage, defaultRows, onPaginateData, page, totalRecords]);

  useEffect(() => {
    if (isFromPatientDetail || isFromTodo) {
      setPage(1);
      setPages([1, 2, 3]);
    }
  }, [totalRecords, selcetedPeriod]);

  useEffect(() => {
    if (activePage) {
      setPage(activePage);
      if (activePage && activePage > 3) {
        setPages([activePage - 2, activePage - 1, activePage]);
      } else {
        setPages([1, 2, 3]);
      }
      onPaginateData(defaultRows, activePage);
    }
  }, [activePage, totalRecords]);

  const pageChange = (val) => {
    if (page !== Number(val)) {
      onPaginateData(defaultRows, Number(val));
      setPage(Number(val));
      checkLastPage(val, defaultRows);
    }
  };

  const arrowPageChange = (op) => {
    const p = [...pages];
    if (op === "prev") {
      pageChange(page - 1);
      if (p[0] !== 1) {
        p.unshift(pages[0] - 1);
        p.pop();
      }
    } else {
      pageChange(page + 1);
      p.push(pages[2] + 1);
      p.shift();
    }
    setPages(p);
  };
  return (
    <nav aria-label='Page navigation example' className='pagination-main'>
      <ul className='pagination mb-2 mb-2 justify-content-center align-items-center '>
        <li className='page-item'>
          <Button
            title={"Previous"}
            btnClassname={"page-link prev"}
            btnDisabled={page === 1 ? "disabled" : ""}
            action={() => arrowPageChange("prev")}
          >
            <i className='fas fa-arrow-left'></i>
          </Button>
        </li>
        {pages &&
          pages.length &&
          pages.map((p) => (
            <li className='page-item' key={p}>
              <button
                className={page === p ? "page-link active" : "page-link"}
                aria-current={page === p ? "true" : "false"}
                disabled={calculatedPages < p ? "disabled" : ""}
                onClick={() => pageChange(p)}
              >
                {p}
              </button>
            </li>
          ))}
        <li className='page-item'>
          <Button
            title={"Next"}
            btnClassname={"page-link next"}
            btnDisabled={onLastPage ? "disabled" : ""}
            action={() => arrowPageChange("next")}
          >
            <i className='fas fa-arrow-right'></i>
          </Button>
        </li>
      </ul>
    </nav>
  );
};

Paginator.propTypes = {
  defaultRows: PropTypes.number.isRequired,
  totalRecords: PropTypes.number.isRequired,
  onPaginateData: PropTypes.func.isRequired,
  isFromPatientDetail: PropTypes.bool,
  isFromTodo: PropTypes.bool,
  selcetedPeriod: PropTypes.string,
  activePage: PropTypes.number,
};
Paginator.defaultProps = {
  isFromPatientDetail: false,
  isFromTodo: false,
  selcetedPeriod: "",
  activePage: null,
};

export default Paginator;
